import React from 'react'
import { Pressable } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import styled from 'styled-components/native'

import { popToNative } from 'APP/BrownfieldBridge/BrownfieldBridgeInternal'
import Typography from 'APP/Converse/Typography'

const Container = styled(SafeAreaView).attrs({ edges: ['top'] })`
  background-color: ${({ theme }) => theme.colors.bannerBg};
  padding-vertical: ${({ theme }) => theme.metrics.baseMargin};
`

export const PopToNativeBanner = () => {
  return (
    <Container testID="POP_TO_NATIVE_BANNER">
      <Pressable onPress={() => popToNative(true)}>
        <Typography align="center" variant="link">
          {'Pop to Native'}
        </Typography>
      </Pressable>
    </Container>
  )
}
